export function changeImage(e){
    let actualImage = document.getElementsByClassName('image--active')[0];

    actualImage.classList.remove('image--active');

    let id = e.target.dataset.index;

    console.log(id);

    document.getElementById('image--' + id).classList.add('image--active');
}